export const getVersion = () => 1;
export const isTablet = () => false;
export const hasNotch = () => false;
export const hideAsync = () => {};
export const preventAutoHideAsync = () => {};
export const useFonts = () => {};
export const UnavailabilityError = () => {};
export const injectEventPluginsByName = () => {};
export default {};
export const Video = () => {};
export const reloadAsync = () => {};
export const Platform = () => {};
export const brand = () => {};
export const modelName = () => {};
export const locale = () => {};
export const createIconSet = () => {};
export const CryptoDigestAlgorithm = () => {};
export const cacheDirectory = () => {};
export const digestStringAsync = () => {};
export const downloadAsync = () => {};
export const getInfoAsync = () => {};
export const ColorPropType = {};
export const ViewPagerAndroid = {};
export const AsyncStorage = {};
export const isDevice = () => {};
export const getExpoPushTokenAsync = () => {};
export const getPermissionsAsync = () => {};
export const requestPermissionsAsync = () => {};
export const setNotificationHandler = () => {};
export const lockAsync = () => {};
export const OrientationLock = {
  LANDSCAPE: 'LANDSCAPE',
};
export const Image = ({ source, style, children }) => {};
export const requestTrackingPermissionsAsync = async () => ({ status: 'undetermined' });